import React, { useState } from 'react';
import {
  RefreshCw, Upload, Search, Filter, ChevronDown, Eye, FileText,
  CheckCircle, Clock, AlertTriangle, Package, Download, MoreVertical,
  ChevronRight, X, Truck, DollarSign, Scale, Box, Users, Layers
} from 'lucide-react';

// Enhanced manifests data with bag details
const manifestsData = [
  {
    id: 'MAN-2026-02-28-001',
    collection: 'COL-2026-02-28',
    date: '2026-02-28',
    source: 'auto',
    bags: 5,
    singles: 12,
    totalWeight: '156.8 lb',
    status: 'processed',
    invoiced: true,
    totalValue: 245680,
    bagDetails: [
      { 
        bagCode: 'FS-BAG-001', 
        tenant: 'FastShip Jamaica', 
        tenantPrefix: 'FS',
        type: 'dedicated',
        packages: 10, 
        weight: '32.5 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 8520,
        totalCost: 10816
      },
      { 
        bagCode: 'QS-BAG-002', 
        tenant: 'QuickShip', 
        tenantPrefix: 'QS',
        type: 'dedicated',
        packages: 20, 
        weight: '45.2 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 11845,
        totalCost: 14141
      },
      { 
        bagCode: 'KPL-MIX-003', 
        tenant: 'Mixed', 
        tenantPrefix: 'KPL',
        type: 'mixed',
        packages: 15, 
        weight: '38.6 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 10115,
        totalCost: 12411,
        mixBreakdown: [
          { tenant: 'BoltShip', packages: 8, weight: '20.5 lb', share: 53.1, allocatedCost: 6590 },
          { tenant: 'KingShip', packages: 5, weight: '12.1 lb', share: 31.3, allocatedCost: 3885 },
          { tenant: 'SpeedyCourier', packages: 2, weight: '6.0 lb', share: 15.6, allocatedCost: 1936 }
        ]
      },
      { 
        bagCode: 'BS-BAG-004', 
        tenant: 'BoltShip', 
        tenantPrefix: 'BS',
        type: 'dedicated',
        packages: 8, 
        weight: '22.3 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 5843,
        totalCost: 8139
      },
      { 
        bagCode: 'KPL-MIX-005', 
        tenant: 'Mixed', 
        tenantPrefix: 'KPL',
        type: 'mixed',
        packages: 10, 
        weight: '18.2 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 4769,
        totalCost: 7065,
        mixBreakdown: [
          { tenant: 'FastShip Jamaica', packages: 6, weight: '10.9 lb', share: 60.0, allocatedCost: 4239 },
          { tenant: 'Island Express', packages: 4, weight: '7.3 lb', share: 40.0, allocatedCost: 2826 }
        ]
      }
    ]
  },
  {
    id: 'MAN-2026-02-27-003',
    collection: 'COL-2026-02-27',
    date: '2026-02-27',
    source: 'auto',
    bags: 4,
    singles: 18,
    totalWeight: '128.4 lb',
    status: 'processed',
    invoiced: true,
    totalValue: 198450,
    bagDetails: [
      { 
        bagCode: 'FS-BAG-006', 
        tenant: 'FastShip Jamaica', 
        tenantPrefix: 'FS',
        type: 'dedicated',
        packages: 15, 
        weight: '42.1 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 11033,
        totalCost: 13329
      },
      { 
        bagCode: 'SC-BAG-007', 
        tenant: 'SpeedyCourier', 
        tenantPrefix: 'SC',
        type: 'dedicated',
        packages: 12, 
        weight: '35.8 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 9381,
        totalCost: 11677
      },
      { 
        bagCode: 'IE-BAG-008', 
        tenant: 'Island Express', 
        tenantPrefix: 'IE',
        type: 'dedicated',
        packages: 18, 
        weight: '28.5 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 7468,
        totalCost: 9764
      },
      { 
        bagCode: 'KPL-MIX-009', 
        tenant: 'Mixed', 
        tenantPrefix: 'KPL',
        type: 'mixed',
        packages: 8, 
        weight: '22.0 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 5764,
        totalCost: 8060,
        mixBreakdown: [
          { tenant: 'QuickShip', packages: 5, weight: '14.0 lb', share: 63.6, allocatedCost: 5126 },
          { tenant: 'MoBay Movers', packages: 3, weight: '8.0 lb', share: 36.4, allocatedCost: 2934 }
        ]
      }
    ]
  },
  {
    id: 'MAN-2026-02-27-002',
    collection: 'COL-2026-02-27',
    date: '2026-02-27',
    source: 'manual',
    bags: 3,
    singles: 8,
    totalWeight: '78.5 lb',
    status: 'pending',
    invoiced: false,
    totalValue: 0,
    bagDetails: [
      { 
        bagCode: 'CC-BAG-010', 
        tenant: 'Caribbean Cargo', 
        tenantPrefix: 'CC',
        type: 'dedicated',
        packages: 14, 
        weight: '38.2 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 10010,
        totalCost: 12306
      },
      { 
        bagCode: 'JQ-BAG-011', 
        tenant: 'JA Quick Delivery', 
        tenantPrefix: 'JQ',
        type: 'dedicated',
        packages: 9, 
        weight: '22.8 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 5974,
        totalCost: 8270
      },
      { 
        bagCode: 'PP-BAG-012', 
        tenant: 'Portmore Parcels', 
        tenantPrefix: 'PP',
        type: 'dedicated',
        packages: 11, 
        weight: '17.5 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 4586,
        totalCost: 6882
      }
    ]
  },
  {
    id: 'MAN-2026-02-26-001',
    collection: 'COL-2026-02-26',
    date: '2026-02-26',
    source: 'auto',
    bags: 6,
    singles: 22,
    totalWeight: '198.3 lb',
    status: 'processed',
    invoiced: true,
    totalValue: 312560,
    bagDetails: [
      { 
        bagCode: 'FS-BAG-013', 
        tenant: 'FastShip Jamaica', 
        tenantPrefix: 'FS',
        type: 'dedicated',
        packages: 22, 
        weight: '58.4 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 15303,
        totalCost: 17599
      },
      { 
        bagCode: 'BS-BAG-014', 
        tenant: 'BoltShip', 
        tenantPrefix: 'BS',
        type: 'dedicated',
        packages: 16, 
        weight: '42.1 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 11033,
        totalCost: 13329
      },
      { 
        bagCode: 'KPL-MIX-015', 
        tenant: 'Mixed', 
        tenantPrefix: 'KPL',
        type: 'mixed',
        packages: 18, 
        weight: '35.6 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 9329,
        totalCost: 11625,
        mixBreakdown: [
          { tenant: 'QuickShip', packages: 7, weight: '14.2 lb', share: 39.9, allocatedCost: 4638 },
          { tenant: 'SpeedyCourier', packages: 6, weight: '11.8 lb', share: 33.1, allocatedCost: 3848 },
          { tenant: 'KingShip', packages: 5, weight: '9.6 lb', share: 27.0, allocatedCost: 3139 }
        ]
      },
      { 
        bagCode: 'SC-BAG-016', 
        tenant: 'SpeedyCourier', 
        tenantPrefix: 'SC',
        type: 'dedicated',
        packages: 12, 
        weight: '28.9 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 7573,
        totalCost: 9869
      },
      { 
        bagCode: 'IE-BAG-017', 
        tenant: 'Island Express', 
        tenantPrefix: 'IE',
        type: 'dedicated',
        packages: 8, 
        weight: '18.3 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 4795,
        totalCost: 7091
      },
      { 
        bagCode: 'MM-BAG-018', 
        tenant: 'MoBay Movers', 
        tenantPrefix: 'MM',
        type: 'dedicated',
        packages: 10, 
        weight: '15.0 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 3931,
        totalCost: 6227
      }
    ]
  },
  {
    id: 'MAN-2026-02-25-002',
    collection: 'COL-2026-02-25',
    date: '2026-02-25',
    source: 'auto',
    bags: 2,
    singles: 5,
    totalWeight: '45.2 lb',
    status: 'error',
    invoiced: false,
    totalValue: 0,
    bagDetails: [
      { 
        bagCode: 'FS-BAG-019', 
        tenant: 'FastShip Jamaica', 
        tenantPrefix: 'FS',
        type: 'dedicated',
        packages: 8, 
        weight: '25.8 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 6761,
        totalCost: 9057
      },
      { 
        bagCode: 'KPL-MIX-020', 
        tenant: 'Mixed', 
        tenantPrefix: 'KPL',
        type: 'mixed',
        packages: 6, 
        weight: '19.4 lb',
        serviceFee: 1000,
        palletFee: 1296,
        freightCost: 5083,
        totalCost: 7379,
        mixBreakdown: [
          { tenant: 'BoltShip', packages: 4, weight: '12.8 lb', share: 66.0, allocatedCost: 4870 },
          { tenant: 'Caribbean Cargo', packages: 2, weight: '6.6 lb', share: 34.0, allocatedCost: 2509 }
        ]
      }
    ]
  }
];

const syncHistory = [
  { time: '10:45 AM', status: 'success', items: 23 },
  { time: '09:30 AM', status: 'success', items: 15 },
  { time: '08:15 AM', status: 'success', items: 31 },
  { time: '07:00 AM', status: 'failed', items: 0 },
];

const formatJMD = (amount) => `J$${(amount || 0).toLocaleString()}`;

// Bag Detail Card Component
const BagDetailCard = ({ bag, index }) => {
  const [expanded, setExpanded] = useState(false);
  const isMixed = bag.type === 'mixed';

  return (
    <div className={`bag-detail-card ${isMixed ? 'mixed' : 'dedicated'}`} data-testid={`bag-${bag.bagCode}`}>
      <div className="bag-header" onClick={() => isMixed && setExpanded(!expanded)}>
        <div className="bag-info">
          <div className="bag-index">{index + 1}</div>
          <div className="bag-code-section">
            <span className="bag-code">{bag.bagCode}</span>
            <span className={`bag-type-badge ${bag.type}`}>
              {isMixed ? <Layers size={12} /> : <Box size={12} />}
              {isMixed ? 'KPL Mix' : 'Dedicated'}
            </span>
          </div>
        </div>
        
        <div className="bag-tenant">
          {isMixed ? (
            <span className="mixed-label">
              <Users size={14} />
              {bag.mixBreakdown?.length} Tenants
            </span>
          ) : (
            <span className="tenant-name">{bag.tenant}</span>
          )}
        </div>
        
        <div className="bag-stats">
          <div className="stat">
            <Package size={14} />
            <span>{bag.packages} pkgs</span>
          </div>
          <div className="stat">
            <Scale size={14} />
            <span>{bag.weight}</span>
          </div>
        </div>
        
        <div className="bag-pricing">
          <div className="price-breakdown">
            <span className="price-item">Service: {formatJMD(bag.serviceFee)}</span>
            <span className="price-item">Pallet: {formatJMD(bag.palletFee)}</span>
            <span className="price-item">Freight: {formatJMD(bag.freightCost)}</span>
          </div>
          <span className="total-cost">{formatJMD(bag.totalCost)}</span>
        </div>
        
        {isMixed && (
          <button className={`expand-btn ${expanded ? 'expanded' : ''}`}>
            <ChevronRight size={18} />
          </button>
        )}
      </div>
      
      {/* KPL Mix Breakdown */}
      {isMixed && expanded && bag.mixBreakdown && (
        <div className="mix-breakdown">
          <div className="breakdown-header">
            <span>Tenant Allocation (Weight-Proportional)</span>
          </div>
          {bag.mixBreakdown.map((tenant, idx) => (
            <div key={idx} className="breakdown-row">
              <div className="tenant-info">
                <span className="tenant-name">{tenant.tenant}</span>
                <span className="share-badge">{tenant.share.toFixed(1)}%</span>
              </div>
              <div className="tenant-stats">
                <span>{tenant.packages} pkgs</span>
                <span>{tenant.weight}</span>
              </div>
              <div className="tenant-cost">
                <span className="allocated-cost">{formatJMD(tenant.allocatedCost)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Manifest Detail Modal
const ManifestDetailModal = ({ manifest, onClose }) => {
  if (!manifest) return null;

  const totalPackages = manifest.bagDetails.reduce((sum, bag) => sum + bag.packages, 0);
  const mixedBags = manifest.bagDetails.filter(b => b.type === 'mixed');
  const dedicatedBags = manifest.bagDetails.filter(b => b.type === 'dedicated');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content manifest-detail-modal" onClick={e => e.stopPropagation()} data-testid="manifest-detail-modal">
        <div className="modal-header">
          <div className="modal-title-section">
            <h3>{manifest.id}</h3>
            <div className="modal-badges">
              <span className={`status-badge ${manifest.status}`}>
                {manifest.status === 'processed' && <CheckCircle size={12} />}
                {manifest.status === 'pending' && <Clock size={12} />}
                {manifest.status === 'error' && <AlertTriangle size={12} />}
                {manifest.status}
              </span>
              {manifest.invoiced && (
                <span className="invoiced-badge yes">
                  <CheckCircle size={12} /> Invoiced
                </span>
              )}
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          {/* Manifest Summary */}
          <div className="manifest-summary">
            <div className="summary-card">
              <Package size={20} />
              <div>
                <span className="value">{manifest.bags}</span>
                <span className="label">Total Bags</span>
              </div>
            </div>
            <div className="summary-card">
              <Box size={20} />
              <div>
                <span className="value">{totalPackages + manifest.singles}</span>
                <span className="label">Total Packages</span>
              </div>
            </div>
            <div className="summary-card">
              <Scale size={20} />
              <div>
                <span className="value">{manifest.totalWeight}</span>
                <span className="label">Total Weight</span>
              </div>
            </div>
            <div className="summary-card highlight">
              <DollarSign size={20} />
              <div>
                <span className="value">{formatJMD(manifest.totalValue)}</span>
                <span className="label">Total Value</span>
              </div>
            </div>
          </div>

          {/* Bag Type Summary */}
          <div className="bag-type-summary">
            <div className="type-stat dedicated">
              <span className="type-label">Dedicated Bags</span>
              <span className="type-value">{dedicatedBags.length}</span>
            </div>
            <div className="type-stat mixed">
              <span className="type-label">KPL Mix Bags</span>
              <span className="type-value">{mixedBags.length}</span>
            </div>
            <div className="type-stat singles">
              <span className="type-label">Singles</span>
              <span className="type-value">{manifest.singles}</span>
            </div>
          </div>

          {/* Bag Details List */}
          <div className="bags-section">
            <h4>Bag Details</h4>
            <div className="bags-list">
              {manifest.bagDetails.map((bag, index) => (
                <BagDetailCard key={bag.bagCode} bag={bag} index={index} />
              ))}
            </div>
          </div>

          {/* Singles Section */}
          {manifest.singles > 0 && (
            <div className="singles-section">
              <h4>Singles ({manifest.singles})</h4>
              <p className="singles-note">Individual packages not assigned to bags. Rate: J$1,500/pkg service + J$648 pallet fee.</p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
          <button className="btn btn-primary">
            <FileText size={16} />
            Generate Invoice
          </button>
        </div>
      </div>
    </div>
  );
};

export default function Manifests() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [selectedManifest, setSelectedManifest] = useState(null);

  const handleSync = () => {
    setSyncing(true);
    setTimeout(() => setSyncing(false), 2000);
  };

  const filteredManifests = manifestsData.filter(m => {
    const matchesSearch = m.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === 'all' || m.status === filterStatus;
    return matchesSearch && matchesFilter;
  });

  return (
    <div className="manifests-page" data-testid="manifests-page">
      {/* Sync Status Banner */}
      <div className="sync-banner">
        <div className="sync-info">
          <div className="sync-status-icon active">
            <RefreshCw size={18} className={syncing ? 'spinning' : ''} />
          </div>
          <div className="sync-details">
            <span className="sync-title">Tasoko Auto-Sync Active</span>
            <span className="sync-subtitle">Last sync: 2 minutes ago • Next sync in 13 minutes</span>
          </div>
        </div>
        <div className="sync-actions">
          <button 
            className="btn btn-secondary"
            onClick={handleSync}
            disabled={syncing}
            data-testid="manual-sync-btn"
          >
            <RefreshCw size={16} className={syncing ? 'spinning' : ''} />
            {syncing ? 'Syncing...' : 'Sync Now'}
          </button>
          <button 
            className="btn btn-primary"
            onClick={() => setShowUploadModal(true)}
            data-testid="upload-manifest-btn"
          >
            <Upload size={16} />
            Manual Upload
          </button>
        </div>
      </div>

      {/* Sync History */}
      <div className="sync-history-row">
        <span className="history-label">Recent Syncs:</span>
        <div className="history-items">
          {syncHistory.map((sync, idx) => (
            <div key={idx} className={`history-item ${sync.status}`}>
              {sync.status === 'success' ? <CheckCircle size={12} /> : <AlertTriangle size={12} />}
              <span>{sync.time}</span>
              {sync.status === 'success' && <span className="item-count">+{sync.items}</span>}
            </div>
          ))}
        </div>
      </div>

      {/* Filters & Search */}
      <div className="page-toolbar">
        <div className="search-box">
          <Search size={18} />
          <input
            type="text"
            placeholder="Search manifests..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            data-testid="manifest-search"
          />
        </div>
        <div className="filter-group">
          <button className="filter-btn" data-testid="filter-btn">
            <Filter size={16} />
            Filter
            <ChevronDown size={14} />
          </button>
          <select 
            className="status-filter"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            data-testid="status-filter"
          >
            <option value="all">All Status</option>
            <option value="processed">Processed</option>
            <option value="pending">Pending</option>
            <option value="error">Error</option>
          </select>
        </div>
      </div>

      {/* Manifests Table */}
      <div className="data-table-card">
        <table className="data-table" data-testid="manifests-table">
          <thead>
            <tr>
              <th>Manifest ID</th>
              <th>Collection</th>
              <th>Date</th>
              <th>Source</th>
              <th>Bags</th>
              <th>Singles</th>
              <th>Total Weight</th>
              <th>Total Value</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredManifests.map((manifest) => (
              <tr key={manifest.id} data-testid={`manifest-row-${manifest.id}`}>
                <td>
                  <span className="manifest-id">{manifest.id}</span>
                </td>
                <td>{manifest.collection}</td>
                <td>{manifest.date}</td>
                <td>
                  <span className={`source-badge ${manifest.source}`}>
                    {manifest.source === 'auto' ? (
                      <>
                        <RefreshCw size={12} /> Auto
                      </>
                    ) : (
                      <>
                        <Upload size={12} /> Manual
                      </>
                    )}
                  </span>
                </td>
                <td>
                  <span className="count-badge bags">{manifest.bags}</span>
                </td>
                <td>
                  <span className="count-badge singles">{manifest.singles}</span>
                </td>
                <td>{manifest.totalWeight}</td>
                <td>
                  <span className="value-cell">
                    {manifest.totalValue > 0 ? formatJMD(manifest.totalValue) : '-'}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${manifest.status}`}>
                    {manifest.status === 'processed' && <CheckCircle size={12} />}
                    {manifest.status === 'pending' && <Clock size={12} />}
                    {manifest.status === 'error' && <AlertTriangle size={12} />}
                    {manifest.status}
                  </span>
                </td>
                <td>
                  <div className="action-buttons">
                    <button 
                      className="action-btn primary" 
                      title="View Details" 
                      data-testid={`view-${manifest.id}`}
                      onClick={() => setSelectedManifest(manifest)}
                    >
                      <Eye size={16} />
                    </button>
                    <button className="action-btn" title="Download" data-testid={`download-${manifest.id}`}>
                      <Download size={16} />
                    </button>
                    <button className="action-btn" title="More" data-testid={`more-${manifest.id}`}>
                      <MoreVertical size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="table-pagination">
        <span className="pagination-info">Showing 1-5 of 247 manifests</span>
        <div className="pagination-controls">
          <button className="pagination-btn" disabled>Previous</button>
          <button className="pagination-btn active">1</button>
          <button className="pagination-btn">2</button>
          <button className="pagination-btn">3</button>
          <span>...</span>
          <button className="pagination-btn">50</button>
          <button className="pagination-btn">Next</button>
        </div>
      </div>

      {/* Upload Modal */}
      {showUploadModal && (
        <div className="modal-overlay" onClick={() => setShowUploadModal(false)}>
          <div className="modal-content upload-modal" onClick={e => e.stopPropagation()} data-testid="upload-modal">
            <div className="modal-header">
              <h3>Upload Manifest/Tally Sheet</h3>
              <button className="close-btn" onClick={() => setShowUploadModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="upload-zone" data-testid="upload-dropzone">
                <Upload size={48} />
                <p>Drag & drop your file here, or <span className="upload-link">browse</span></p>
                <span className="upload-hint">Supports CSV, XLSX, PDF (Max 10MB)</span>
              </div>
              <div className="upload-options">
                <label className="upload-option">
                  <input type="radio" name="uploadType" value="manifest" defaultChecked />
                  <span>Manifest File</span>
                </label>
                <label className="upload-option">
                  <input type="radio" name="uploadType" value="tally" />
                  <span>Tally Sheet</span>
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowUploadModal(false)}>Cancel</button>
              <button className="btn btn-primary" data-testid="upload-submit-btn">
                <Upload size={16} /> Upload File
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Manifest Detail Modal */}
      {selectedManifest && (
        <ManifestDetailModal 
          manifest={selectedManifest} 
          onClose={() => setSelectedManifest(null)} 
        />
      )}
    </div>
  );
}
